/* eslint-disable no-undef, no-unused-vars */

import $ from 'jquery';
import NProgress from '../../vendor/nprogress';

$(document).ready(function() {
  // Loading indicator bar AJAX request handling
  var activeRequests = 0;
  NProgress.configure({
    minimum: 0.5
  });
  $(document).ajaxStart(function() {
    if(activeRequests <= 0) {
      NProgress.start();
    } else {
      NProgress.inc();
    }
    activeRequests++;
  });
  $(document).ajaxStop(function() {
    activeRequests--;
    // Sometimes ajax counter can be negative (not clear why, might happened if a request returned 404)
    if(activeRequests <= 0) {
      NProgress.done();
    }
  });
});
